const StatusModel = {
    succeeded : 'succeeded',
    failed : 'failed',
    unKnown : 'unknown',
    logout : 'logged out',
}

export default StatusModel